import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index"
import { selectDriverFace, updateDriverFace } from '../../../api/config/modules/DriverFaceFile'
export default {
    name: "DriverFaceFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                driverName: '',
                isFaceData: '',
                queryTime: '',
            },
            stateList: [
                { id: '', name: this.$t('common.all') },
                { id: '1', name: this.$t('DriverManagement.correct') },
                { id: '0', name: this.$t('DriverManagement.deny') },
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "driverNum",
                label: this.$t('DriverManagement.driverNum'),
                align: "center",
            },
            {
                prop: "driverName",
                label: this.$t('DriverManagement.name'),
                align: "center",
            },
            {
                prop: "orgName",
                label: this.$t('DriverManagement.orgName'),
                align: "center",

            },
            {
                prop: "faceUpdateTime",
                label: this.$t('DriverManagement.faceUpdateTime'),
                align: "center",
            },
            {
                label: this.$t('common.btn.operate'),
                align: "center",
                width: "120px",
                fixed: "right",
                render: (h, params) => {
                    return h('el-button',
                        {
                            props: {
                                type: 'primary', icon: params.row.faceFilePath === null ? '' : 'iconfont icontupian'
                            },
                            on: {
                                click: () => {
                                    this.imageUrl = params.row.faceFilePath
                                    this.dialogOperateFormVisible = true
                                    this.getOperateList()
                                }
                            }
                        })
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    // {
                    //     id: '1',
                    //     show: true,
                    //     icon: 'iconfont icontupian',
                    //     plain: true,
                    //     disabled: false,
                    //     method: (index, row) => {
                    //         this.imageUrl = row.faceFilePath
                    //         this.dialogOperateFormVisible = true
                    //         this.getOperateList()
                    //     }
                    // }
                ]
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            // 更新人脸数据
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {

            },
            form: {
                file: null,
                imageUrl: null,
            },
            processImg: '',
            FileList: [],
            imageUrl: '',
            selected: [],
            id: '',
            name: '',
            // 详情页面
            dialogOperateFormVisible: false,
        }
    },
    methods: {
        //左侧功能条切换
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        //上方功能条切换
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        //查询
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.selectList()
        },
        //树形图查询
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.selectList()
        },
        selectList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.queryTime) {
                if (this.formInline.queryTime.length > 0) {
                    startTime = this.formInline.queryTime[0]
                    endTime = this.formInline.queryTime[1]
                }
            }
            let param = {
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                isFaceData: this.formInline.isFaceData,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFaceFile/GET_SELECTDRIVERFACE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.selectList()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                isFaceData: '',
                startTime: '',
                endTime: '',
            }
            this.selectList()
        },
        updateDriverFace() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.form.file = file;
                // 读取文件内容，并将图片显示到页面上
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.form.imageUrl = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        submitForm(formName) {
            let formData = new FormData();
            formData.append('file', this.form.file)
            formData.append('driverNum', this.selected[0].driverNum)
            this.$store.dispatch('DriverFaceFile/GET_UPDATEDRIVERFACE', formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('common.btn.editSuccess'))
                    this.dialogFormVisible = false;
                    this.selectList();
                    this.closeDia();
                } else {
                    this.$message.error(res.data.msg)
                }

            }).catch(err => { })
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            this.form = {
                file: null,
                imageUrl: null,
            }
        },
        closeDia() {
            this.dialogFormVisible = false;
            this.form = {
                file: null,
                imageUrl: null,
            }
        },
        exportFile() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.queryTime) {
                if (this.formInline.queryTime.length > 0) {
                    startTime = this.formInline.queryTime[0]
                    endTime = this.formInline.queryTime[1]
                }
            }
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {

                    let url = `https://${domainName}/v1/getExportExcel/exportDriverFace?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&isFaceData=${this.formInline.isFaceData}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadDriverFinger?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&isFaceData=${this.formInline.isFaceData}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        //行选择
        handleSelectionChange(val) {
            this.selected = val
        },
        //换页
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.selectList();
        },
        //查看详情
        getOperateList() {
            this.dialogOperateFormVisible = true
        },
        //关闭详情
        closeOperateDia() {
            this.imageUrl = null
            this.dialogOperateFormVisible = false
        },
        //行选择
        selectedChanged(val) {
            this.select = val
        },
        //下方切换表格
        changePageSize(item) {
            this.PageSize = item.pageSize
            this.CurrentPage = item.pageNum
            this.selectList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}